import svgUrl from "ni:svgr;Ms6mLCvSibEwW6ATIUNgqnSRk3NJfd3N7pcpNF0A63s";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgChevronUp = props => <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.646 8.354a.5.5 0 0 0 .708 0L6 4.707l3.646 3.647a.5.5 0 1 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708Z" fill="currentColor" /></svg>;
const Memo = memo(SvgChevronUp);
export { Memo as ReactComponent };